/**
 * External dependencies
 */
import {
  dataPixels,
  DEFAULT_ASSET_PAGE_RATIO,
  PAGE_HEIGHT,
  PAGE_WIDTH,
} from '@web-stories-wp/units';

export const LOTTIE_ELEMENT_TYPE = 'lottie';
export const DEFAULT_LOTTIE_LIBRARY_PAGE_SIZE = 24;

const getPositiveNumber = (value) => {
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
};

export const getLottieAspectRatio = ({
  intrinsicWidth,
  intrinsicHeight,
  width,
  height,
}) => {
  const sourceWidth = getPositiveNumber(intrinsicWidth || width);
  const sourceHeight = getPositiveNumber(intrinsicHeight || height);

  if (!sourceWidth || !sourceHeight) {
    return 1;
  }

  return sourceWidth / sourceHeight;
};

export const getLottiePlacedSize = (snapshot) => {
  const ratio = getLottieAspectRatio(snapshot);
  let width = PAGE_WIDTH * DEFAULT_ASSET_PAGE_RATIO;
  let height = width / ratio;

  if (width > PAGE_WIDTH || height > PAGE_HEIGHT) {
    const pageRatio = PAGE_WIDTH / PAGE_HEIGHT;

    if (ratio <= pageRatio) {
      height = Math.min(height, PAGE_HEIGHT);
      width = height * ratio;
    } else {
      width = Math.min(width, PAGE_WIDTH);
      height = width / ratio;
    }
  }

  return {
    width: dataPixels(width),
    height: dataPixels(height),
  };
};

const formatCompactNumber = (value, fallback = '') => {
  const parsed = Number(value);

  if (!Number.isFinite(parsed)) {
    return fallback;
  }

  return Number.isInteger(parsed) ? String(parsed) : parsed.toFixed(1);
};

export const formatAnimationMetadata = (animation) => {
  const width = getPositiveNumber(animation.width);
  const height = getPositiveNumber(animation.height);
  const size = width && height ? `${width} x ${height}` : '';
  const duration = getPositiveNumber(animation.duration)
    ? `${formatCompactNumber(animation.duration)}s`
    : '';
  const fps = getPositiveNumber(animation.fps)
    ? `${formatCompactNumber(animation.fps)}fps`
    : '';

  return [size, duration, fps].filter(Boolean).join(' - ');
};

export const mergeAnimationPages = (currentAnimations, newAnimations) => {
  const seenIds = new Set(currentAnimations.map(({ id }) => id));
  const dedupedNewAnimations = newAnimations.filter(({ id }) => {
    if (!id || seenIds.has(id)) {
      return false;
    }

    seenIds.add(id);
    return true;
  });

  return [...currentAnimations, ...dedupedNewAnimations];
};
